export enum RATING_TYPE {
  HATE = 1,
  DISLIKE = 2,
  NEUTRAL = 3,
  LIKE = 4,
  LOVE = 5,
}

export type RatingFilterValue = RATING_TYPE[] | undefined;

export enum CompletionOptions {
  COMPLETE = 'complete',
  INCOMPLETE = 'incomplete',
  ALL = 'all',
}

export enum RecordingOptions {
  CAPTURED = 'captured',
  NOT_CAPTURED = 'not_captured',
  ALL = 'all',
}

export type CompletionFilterValue = CompletionOptions | undefined;

export type RecordingFilterValue = RecordingOptions | undefined;
